import "../books.css";

const two = (
  <div>
    <h2 id="shoes-and-stories">Shoes and Stories</h2>
    <p>
      The wide cobblestone street was lined on both sides by a number of
      businesses. Later in the day afternoon traffic would pack the street but
      the early morning light revealed only a scattered few commuters.
    </p>
    <p>
      A man could buy anything he needed walking from one end of the street to
      the other, if he had the money. Signs, placed on each building without
      fail, proclaimed a variety of trades and wares.
    </p>
    <p>
      There was a store that sold guns and tinware, a cobbler, a clothing store,
      a carpenter, a barber’s shop, and many more. And if, by some chance, the
      numerous specialized stores and tradesmen didn’t have the wares one was
      looking for then the center of the street held a general store, filled
      with an assortment of necessities and desirables.
    </p>
    <p>
      The storefront was a dull beige, with two large windows on either side of
      the faded black door. It was not the newest or most expensive of the
      buildings, but it was larger than most, and the clear windows, tidy
      interior, and clean walls showed it was well cared for.
    </p>
    <p>
      In front of the store, blocking a portion of the beige colored wall, was a
      padded wooden chair, elevated onto a platform that hosted footrests. Next
      to the chair stood two boys, one notably cleaner than the other and
      neither older than eleven.
    </p>
    <p>
      “C’mon Jaeger, at least you have Sundays off.” the cleaner boy said. Said
      with a different tone it could have been an arguement or a complaint but
      in the soft friendly voice he used it was an encouragement.
    </p>
    <p>
      “Yeah.” the dirtier boy, Jaeger, said, though he sounded glum and
      altogether not encouraged. Like a great many of New York boys there was a
      little reason to be encouraged, Jaeger worked twelve hours a day at the
      factory and on a Tuesday morning, Sunday seemed far away.
    </p>
    <p>
      “Here.” the cleaner boy said with a smile and a flourish of his hand,
      which came out of his jacket holding a couple of peppermint drops, one of
      which he dropped onto Jaeger’s hand while the other landed into his own
      mouth.
    </p>
    <p>
      “Thanks Billy,” Jaeger said, his voice slightly garbled by the fresh
      peppermint drop in his mouth. “You filch ‘em?”
    </p>
    <p>
      “Nope, ‘ol Abrams talks mean but he’s sweet on the inner, he offered a
      sweet and I asked for another for you.” the cleaner boy, Billy, replied,
      his voice similarly garbled by the hard candy in his mouth.
    </p>
    <p>
      They stood there in comfortable silence for a few minutes, savoring the
      sweet mint before Jaeger had to leave for work, motioning farewell with a
      nod of his head.
    </p>
    <p>
      Billy remained by the chair where he worked as a shoe shiner, sharing
      profits with ‘ol Abrams who owned the store, the shoe shining chair, and
      the wax.
    </p>
    <p>
      Unlike Jaeger, who worked at the factory, Billy rather liked his job. He
      had been lucky to get it, an opportunity given to him by an old and faded
      friendship between his mother and ‘ol Abrams’ wife.
    </p>
    <p>
      Billy was also quite good at his job. It did not seem like shoe shining
      was a job that took much skill and, truthfully, it didn’t. But there was a
      foot inside those shoes, and attached to that foot was a body and inside
      that body was a person.
    </p>
    <p>
      That person, more like than not, had extra change in their pockets, for
      why else would they be getting their shoes shined, and failing that, they
      had something interesting to say.
    </p>
    <p>
      Billy reckoned, in some less exact words, that there was a certain
      combination of words that, said in a certain way, would convince any man
      who got his shoes shined to leave behind an extra penny or more.
    </p>
    <p>
      He thought of the words as a key, and each man a lock. The challenge was
      that each lock required its own unique key, and that was what Billy loved
      - the challenge.
    </p>
    <p>
      Some keys were long and tricky whereas others were short and simple. Some
      had teeth jagged and steep while others were smooth and shallow. Some keys
      were not so different from each other, while others were so foreign and
      mangled that he rarely made any progress with them.
    </p>
    <p>
      Billy had a knack for figuring out these keys. It was not something he
      could explain or teach or even understand; he simply felt it out,
      subconsciously reading into the uncountable subtle details of the lock
      that wore the shoes he shined.
    </p>
    <p>
      On rare occasions, when Billy managed to follow the longer and trickier
      keys, unexpected results occurred. Once a man, who had arrived solemn
      faced and serious, had gone to his hands and knees in front of Billy,
      looking at him with eyes red with tears and praising him for a saint.
      Billy hadn’t known what he had said that meant so much to the man, he
      hadn’t know what the man’s reaction would be, but that was the result of
      the key.
    </p>
    <p>
      “C’me shiny your shoes, finest wax this side of the Mississippi!” Billy
      called out to the scarce traffic, eyeing a moderately well-dressed man
      with dull shoes.
    </p>
    <p>
      It must be said that Billy’s claim was not true. In fact, the statement
      did not hold even for Billy’s side of the street, seeing that the
      cobbler&#39;s shiner had wax both shinier and more pleasant to the nose.
    </p>
    <p>
      “Finest wax this side of the Mississippi, eh? The man approached, his
      voice light and amused. He was middle-aged, perhaps in his mid-thirties,
      with black hair already tinged by gray. There was a faded southern draw to
      his words and he had a particularly non new-yorkian fashion of walking.
      These details, and a thousand more invisible to the conscious mind, told
      Billy the man had not been born in the city.
    </p>
    <p>
      “Yessir, an’ I reckon it’s the finest on the far side too.” Billy replied,
      smiling brightly at the man. Shining the shoes of businessmen had given
      Billy what his mother called a “learnt talk,” though it was really just a
      few words like “reckon” or “venture” he had guessed the meaning to and
      added to his vocabulary.
    </p>
    <p>
      The man gave a small chuckle and walked up to the chair, stepping up the
      platform and easing into the seat, setting his briefcase down beside him.
    </p>
    <p>
      “Well then, I can’t refuse that. What’s your name boy?” The man asked,
      placing his feet on the footrests and relaxing comfortably in the chair.
    </p>
    <p>
      “William, my ma’ named me, but everyone calls me Billy. And your name,
      sir?” Billy knew to ask for his name; it was part of the key.
    </p>
    <p>
      “Charles,” the man relied. “Or Dr. Clark, whichever you prefer.” It was at
      this point Billy fully realized the man was no simple lock.
    </p>
    <p>
      Billy’s wordless interpretation of the man, Charles, is best described as
      a peculiar box. Each side of the box held a thousand keyholes, all
      different and unique. And contained inside the box were just as many
      compartments, every one linked to a single key.
    </p>
    <p>
      Most men that sat to shine their shoes were rigid businessmen, too busy
      thinking about their next deal or reading the latest print of the Times to
      spare Billy more than a passing glance. These men rarely held more than a
      few compartments, but a few times a month Billy encountered a different
      kind of people, men with a receptive mind and open eyes.
    </p>
    <p>
      Charles was one of these men. And so Billy was unsure of even the simple
      question of what to call him. Billy chose to call him Charles, for the
      sole reason that he had never heard a doctor give away his first name
      without the required prefix.
    </p>
    <p>“Hows’ the morning a’ treatin’ you Charles sir?</p>
    <p>
      “Pleasant enough I might say. I’ll be heading out of the city after a bit
      of business and day ahead looks as fair as one could ask it to be.”
      Charles replied as Billy dabbed his cloth into the wax and began to shine
      Charles’ shoes. “And your day Billy?”
    </p>
    <p>
      “As well as can be hoped sir. A drop of peppermint to start the day and a
      bright spring sky.” It was more than Billy would have said to most men,
      but then Charles was not most men.
    </p>
    <p>
      There were two norms to Billy’s conversation at this point. The first was
      flattery, subtly, or not so subtly depending on the person, complementing
      the customer’s demeanor or appearance. Said right, there were few men who
      did not appreciate a compliment, particularly a well placed one.
    </p>
    <p>
      The second was agreement. The most common topic was political - simply
      agreeing about the post-war nature of the South or on tariffs that Billy
      knew nothing about did wonders for ingratiating himself with the customer.
    </p>
    <p>
      The use of these norms was unclear with a man like Charles, but even so,
      they rarely hurt. Billy noted yesterday’s paper on top of Charles’
      briefcase, the front page reading “
      <em>Custard’s Last Stand: Outnumbered and Overwhelmed by Savages.</em>”
    </p>
    <p>
      It was a rare man who didn’t support a war hero, and an even rarer one
      that sympathized with the Reds.
    </p>
    <p>“A shame it is, the Reds getting Custard.” Billy said.</p>
    <p>
      “Indeed it is.” Charles replied and, despite the agreeable nature of his
      response, Billy knew it had been the wrong thing to say.
    </p>
    <p>
      The key was not broken, but no longer would it fit into the most prized
      compartments. It was restricted to the mundane, normal conversations
      common in the day. Billy felt some loss at it, seeing the potential of
      their conversation suddenly close.
    </p>
    <p>
      “How fare your mother and father Billy?” Charles asked, his voice
      genuinely curious. In a year of shining shoes and talking Billy had never
      heard the question before.
    </p>
    <p>
      “My Ma is fine sir. I never seen my Pa. My Ma says he’s a god-forsaken
      bastard and making me was the only decent thing he’s done his whole life.”
    </p>
    <p>Charles chuckled, not unkindly. “Your Ma sounds like a fine woman.”</p>
    <p>
      Billy replied affirmatively and their conversation continued as he shined
      the man’s shoes. He learned Charles was a traveling doctor from the South,
      and had been treating a wealthy client in the city.
    </p>
    <p>
      Soon enough the shoes on Charles’ feet were shiny and Billy’s job was
      done. He still felt a sense of loss at the missing compartments but he
      cheered up quickly enough when Charles tossed him dime as he said
      farewell.
    </p>
    <p>
      Billy pocketed seven pennies on the exchange. Old Abrams charged a nickel
      to shine at his chair and took three pennies out of every exchange. The
      rest was Billy’s.
    </p>
    <p>
      The rest of the day was uneventful in Billy’s eyes, with only one other
      notable encounter, seeing Uncle Ben who was as boisterous, bright eyed,
      and round as ever, walk by.
    </p>
    <p>
      Uncle Ben was a storyteller, he made a living orating tales in factories
      while the men worked, though Billy always thought the cut of his cloth and
      glisten of his watch was too rich for storytelling alone.
    </p>
    <p>
      Uncle Ben, who was really Jaeger’s uncle, not Billy’s, told stories in
      Drains Tavern every Thursday night to anyone who spent a two-penny to
      enter.
    </p>
    <p>
      Billy had never heard anyone weave a tale quite like Uncle Ben. His voice,
      both deep and rich, pulled the curtains of imagination down across Billy’s
      eyes before vividly filling his mind with foreign landscapes, heroes,
      villains, and all the sorts in between.
    </p>
    <p>
      Billy would have loved to talk and try to pry out which story Uncle Ben
      would be telling tonight but it was midday, and he was busy shining the
      shoes of a presumptuous businessman with a remarkably large nose. So Uncle
      Ben passed him with a jovial wink and left Billy even more curious about
      tonight’s tale as he shined and talked the day away.
    </p>
    <hr />
    <p>
      The sky was starting to get dark when Billy called it a day, pulling the
      chair and platform back under cover and storing away the wax and cloth
      inside the store. Abrams had gone home, so he settled the store’s take
      from the shining today with the assistant and headed off to fetch Jaeger,
      who would be getting off work any moment now.
    </p>
    <p>
      He headed off through the city, comfortable in the alleys and roads that
      he knew like the back of his hand despite the approaching darkness and the
      less than friendly nature of some of New York City’s inhabitants.
    </p>
    <p>
      Jaeger was walking out of the factory, visibly tired from the long day of
      work, but his eyes still lit up when he saw Billy. “Do you know what story
      Uncle Ben’s telling tonight?”
    </p>
    <p>
      “Nope,” Billy said. “But I bet it’s about the Red, he hasn’t told a story
      about him in almost two months.”
    </p>
    <p>
      “It’s been even longer since we’ve heard of Desert Rose. Put a penny on
      it?.” Jaeger replied.
    </p>
    <p>
      “Deal!” Billy spat in his hand and held it out to Jaeger, who did the same
      before shaking. They continued arguing about who they would hear about
      tonight as they made their way towards the tavern.
    </p>
    <p>
      Drains Tavern was not a particularly quality establishment but it served a
      gill of whiskey for a penny less than its closest competitor and found
      itself near a full bar at the end of every week. Thursday nights,
      generally slow by a simple fact of the business, brought a spectacle that
      not only filled the bar but the wide unused space that had held wares when
      the building had been a shop. The spectacle was none other than Uncle Ben.
      His smooth, molasses thick, and honey sweet words drew men and children
      alike to hear tales he claimed were gathered straight from the mouths of
      heroes and witnesses.
    </p>
    <p>
      The two of them passed through the entrance with their two-penny
      admittance, Billy exchanging smiles and quick words with the doorman. It
      was already filling; every slum-child with a two-penny and time to spare
      -which wasn’t truly that many of them- came to Drains.
    </p>
    <p>
      Uncle Ben sneaked them a wink when he saw them enter but he was already
      beginning his performance, simply by the quiet but constant force of his
      presence. Billy and Jaeger found their friends on the floor and joined in
      on the chatter that always preceded the Thursday night tale. A suspense
      slowly filled the air, invisible and seemingly uncaused but spreading
      nonetheless. As it rose the noise of the tavern began to recede until all
      those speaking were whispering and even the creaks of the bar stools and
      the hardwood floor seemed to subside. Finally, a soft yet powerful ahem
      rang through the room and both the suspense and remaining noise instantly
      dissipated.
    </p>
    <p>
      “Henry Plummer was the meanest man to ever touch a saddle. And the nine
      men that rode beside him formed the vilest group in the West. Covered in
      sin and dripping with evil, they styled themselves the Innocents, and
      every man on the far side of the Mississippi knew the name. They forged
      their infamy through a series of misdeeds, a wanton trail of death and
      thievery the set a bounty to each of their heads.
    </p>
    <p>
      But even the hardest of bounty hunters stayed away. Claiming one of their
      bounties would bring the rest, nine bloodthirsty riders, down on your
      head. So the Innocents rode outside the law and wise folk kept their
      distance.
    </p>
    <p>
      Their downfall came when Plummer’s cousin, Rasley Ben, was dragged dead to
      the sheriff of Dodge city. The claimant was none other than the Desert
      Rose, -“
    </p>
    <p>Billy elbowed Jaeger, who grudgingly handed over a penny.</p>
    <p>“- The Lady Death herself.</p>
    <p>
      Plummer caught wind of his cousin’s fate passing through Nevada and led
      his Innocents east, set to hunt a legend of the West for vengeance and
      infamy.
    </p>
    <p>
      It was by chance, more than any measure of skill, that crossed their paths
      in the town of Miles. Miles was a mean place, made mostly of a tavern, an
      inn, and a store, all in the same building. Having been raised by the
      birth of a railroad but abandoned in its completion few came to the town,
      and those that did come held a price on their head more oft than not.
      Naturally the Innocents came by on their way through the area.
    </p>
    <p>
      When Vernan and Gent of the Innocents ran into Rose, her back turned to
      them, in the stables they thought it fine luck. Had they known better they
      would have seen it for the misfortune it was.
    </p>
    <p>
      The two of them were not so stupid as to let her know that they were
      there, drawing while she faced away and firing as they raised their arms.
      But some say Rose has eye hidden in the back of her head and it’s known
      she has the speed of a reared viper. Vernan and Gent fired and Rose dove,
      her revolvers finding her hands as fast as magic. Which of the two men
      landed their bullet firmly in Rose’s leg can’t be known, but money goes on
      Gent, on account of him being a better shot and the fact that Rose’s
      returning shot on him rang through his skull, while Vernan was only hit in
      the shoulder.
    </p>
    <p>
      Vernan ran for cover and the Innocents aid while Rose ran for the stallion
      near as famed as herself, dark coated Drexler. She did not bother saddling
      the beast, stopping only to grab her two Geven Repeaters before leaping
      atop, the blood pouring from her leg ignored in her typical unnatural
      fashion.
    </p>
    <p>
      When Plummer and his gang stormed the stables Drexler was already running
      outside, but it was far from over. The Innocents’ blood ran hot with rage
      and liquid courage and raced to untether their still saddled horses. They
      rose to horseback and gave chase with Rose still well in sight, drawing
      rifles and hollering like a Seminole warband.
    </p>
    <p>
      Drexler ran like wind unleashed, cutting through the empty plain that set
      itself around Miles and sprinting for the tree line that lined the
      horizon. Rose held a rifle in each hand on a bareback horse with her
      bleeding leg covering Drexler’s side in dark red and still she out rode
      the Innocents.
    </p>
    <p>
      When she disappeared in the woods ahead the eight uninjured Innocents
      should have gave it up for lost but they spread and chased.
    </p>
    <p>
      Soon the shadows themselves seemed to fire at the Innocents. What had
      before seemed as harmless as the shade of the tree shot hot lead and death
      into gang of men. Screams spread through the men as they fell from their
      saddles, either lifeless or wounded.
    </p>
    <p>
      It was not long before the Innocents ran but only Plummer made it back to
      Miles alive and bleeding from his side. There was a haunt to his eyes and
      even the rough nail-tough crowd in the tavern felt a chill at the sight of
      his face.
    </p>
    <p>
      Plummer patched his side and ran for it with Vernan at his side. But their
      bodies weren’t missing when Rose led a train of ten horses and ten dragged
      bodies into Dodge”
    </p>
    <p>
      There was a silence in the tavern, stories of Rose were fascinating, but
      they were seldom cheery.
    </p>
    <p>“And as Rose claimed her bounty, the land to West held the Red…”</p>
    <p>
      Jaeger elbowed Billy, and he handed back the penny with a laughing smile
      and mock reluctance. The mood had lightened with the mention of Red’s
      name, the crowd favorite of western heroes.
    </p>
    <p>
      While many of the adults stayed late into the night, slowly drowning in
      their cups, the children always left when the stories ended. Rather than
      fight through the crowd around Uncle Ben, where he was gathering free
      drinks and compliments, Billy and Jaeger left with a wave and hurried back
      home; Ma didn’t like when they got back late and they were hungry for
      dinner.
    </p>
    <p>
      Their ongoing chatter as they made their way through the New York streets
      was cut abruptly as they noticed the smoke rising in the air ahead of
      them. Billy couldn’t tell from where he stood, but the smoke seemed to be
      coming from their home. The two of them ran ahead, cutting through a dark
      alley, leaping over the piles of trash that stood in its entryway.
    </p>
    <p>
      Their fears were confirmed as turned the corner, staring straight into the
      burnt husk of the building in which they had lived. Through the flickering
      flames and crumbling walls they glanced two bodies both completely
      unrecognizable and disturbingly familiar. And, even as they glimpsed a
      sight that upturned the lives of the two boys something hard and fast
      slammed into each of their heads, instantly rendering them unconscious.
    </p>
  </div>
);

export default two;
